import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  ModelSignal,
  OutputEmitterRef,
  Signal,
  WritableSignal,
  computed,
  input,
  linkedSignal,
  model,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { FilterSelectionOption } from '../../models';
import { FilterGroupComponent } from '../filter-group/filter-group.component';
import { FilterSelectionInfoComponent } from '../filter-selection-info/filter-selection-info.component';
import { SingleSelectionFilterComponent } from '../single-selection-filter/single-selection-filter.component';

@Component({
  selector: 'mp-single-selection-group',
  templateUrl: './single-selection-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule, FilterGroupComponent, SingleSelectionFilterComponent, FilterSelectionInfoComponent],
})
export class SingleSelectionGroupComponent<T> {
  readonly options: InputSignal<FilterSelectionOption<T>[]> = input.required<FilterSelectionOption<T>[]>();
  readonly selectedValue: InputSignal<T | undefined> = input<T | undefined>();

  readonly filterName: InputSignal<string> = input.required<string>();
  readonly icon: InputSignal<string | undefined> = input<string>();

  readonly isExpanded: ModelSignal<boolean> = model<boolean>(true);

  readonly showSelectionInfo: InputSignal<boolean> = input<boolean>(false);

  readonly selectedValueChange: OutputEmitterRef<T> = output<T>();

  readonly optionSelect: OutputEmitterRef<FilterSelectionOption<T>> = output<FilterSelectionOption<T>>();

  protected readonly currentValue: WritableSignal<T | undefined> = linkedSignal(() => this.selectedValue());

  protected readonly selectedOption: Signal<FilterSelectionOption<T> | undefined> = computed(() => {
    return this.currentValue() && this.options().find((option) => option.value === this.currentValue());
  });

  onSelectionChanged(selectedValue: T): void {
    this.currentValue.set(selectedValue);
    this.selectedValueChange.emit(selectedValue);
  }

  onOptionSelected(selectedOption: FilterSelectionOption<T>): void {
    this.optionSelect.emit(selectedOption);
  }
}
